import { render, staticRenderFns } from "./CreateDepot.vue?vue&type=template&id=76d8e635"
import script from "./CreateDepot.vue?vue&type=script&lang=js"
export * from "./CreateDepot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports